// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\">Quick and Easy Account Management</h2> <p>We make it simple for you to understand and manage your account, so you&#39;ll have more time to focus on the other priorities in your life.</p> ";
// Exports
export default code;